import React, {useEffect, useState} from "react";

import {emptyString} from "../../../../utils/stringUtils";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import SimpleTable from "../../../common/tables/SimpleTable";
import {useDispatch, useSelector} from "react-redux";
import {deleteTbInfo, loadTbInfo, saveTbInfo} from "../../../../actions/tbInfoActions";
import MaterialUISelect from "../../../common/selects/MaterialUISelect";
import useThemeChange from "../../../../hooks/useThemeChange";
import {LIGHT_THEME, TB_STATUS_ACTIVE, TB_STATUS_HIDDEN} from "../../../../utils/constants";
import TbInfoEditPopover from "./TbInfoEditPopover";
import ActionPopover from "../../../common/popovers/ActionPopover";
import {isAdmin, isAdminAsPartner} from "../../../../utils/authUtils";
import {isDesktop} from "../../../../utils/displayUtils";

export default function TrafficBackInfoTable({}) {
    const dispatch = useDispatch();
    const tbInfoData = useSelector(state => state.tbInfoReducer.tbInfoData);

    const [searchData, setSearchData] = useState({code: "", description: ""});
    const [selectedOperator, setSelectedOperator] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [operators, setOperators] = useState([]);

    useEffect(() => {
        dispatch(loadTbInfo());
    }, []);

    useEffect(() => {
        if (!tbInfoData) {
            return;
        }
        const operatorIds = [];
        const operatorsData = [];
        let operator_all = null;
        tbInfoData.forEach(tbItem => {
            if (!operatorIds.includes(tbItem.operatorId)) {
                const operator = {id: tbItem.operatorId, name: tbItem.operatorName};
                operatorIds.push(tbItem.operatorId);
                if (tbItem.operatorId === -2) {
                    operator_all = operator;
                } else {
                    operatorsData.push(operator);
                }
            }
        });
        setOperators([operator_all, ...operatorsData]);
    }, [tbInfoData]);

    useEffect(() => {
        if (!tbInfoData) {
            return;
        }
        const filteredData = tbInfoData.filter(tbInfo => (
            (emptyString(searchData.code) || tbInfo.code?.toLowerCase().includes(searchData.code?.toLowerCase()))
            && (emptyString(searchData.description) || tbInfo.description?.toLowerCase().includes(searchData.description?.toLowerCase()))
            && (!selectedOperator || selectedOperator.name === tbInfo.operatorName)
        ));
        setFilteredData(filteredData);
    }, [tbInfoData, searchData, selectedOperator]);


    const handleTyping = (e) => {
        const fieldName = e.target.name;
        const value = e.target.value;
        setSearchData({...searchData, [fieldName]: value})

    };

    const handleClearSearchData = () => {
        setSearchData({code: "", description: ""});
        setSelectedOperator(null);
    };

    const handleSave = (body) => {
        dispatch(saveTbInfo(body, () => dispatch(loadTbInfo())));
    };

    const toggleHiddenFromPartner = (item) => {
        const operator = item.operatorId === -2 ? null : {id: item.operatorId};
        const body = {...item, operator: operator, status: item.status === TB_STATUS_HIDDEN ? TB_STATUS_ACTIVE : TB_STATUS_HIDDEN};
        handleSave(body);
    };

    const themeName = useThemeChange();

    const dropDownStyles = {
        root: {
            padding: "0",
            minWidth: 150,
            maxWidth: 200,
            underlineBorderBottom: '0px solid rgba(0,0,0,0) !important',
        },
        input: {
            backgroundColor: themeName === LIGHT_THEME ? "white" : "#1c1c1e",
            border: themeName === LIGHT_THEME ? "1px solid #ced4da" : "1px solid #000",
            borderRadius: ".25rem",
            fontSize: '12px !important',
            padding: "0 0 0 5px",
            minHeight: "37px",
            height: "37px"
        },
        placeholder: {
            fontSize: "12px !important",
            padding: "0 0 3px 5px",
        }
    };

    const tableColumns = () => {
        return [
            {
                name: "Код ТБ",
                key: "code",
                getBodyCellValue: item => item["code"],
                headerCellStyle: {minWidth: "200px", maxWidth: "250px"},
                bodyCellStyle: {textAlign: "left", width: "250px", maxWidth: "250px"},
            },
            {
                name: "Оператор",
                key: "operatorName",
                getBodyCellValue: item => item["operatorName"],
                headerCellStyle: {minWidth: "150px", maxWidth: "200px"},
                bodyCellStyle: {textAlign: "left", width: "200px", maxWidth: "200px"},
            },
            {
                name: "Описание",
                key: "description",
                getBodyCellValue: item => item["description"],
                bodyCellStyle: {textAlign: "left", maxWidth: "350px"},
            },
            {
                name: (isAdmin() && !isAdminAsPartner())
                    ? <TbInfoEditPopover button={<i className="ti ti-plus td-save" title="Редактировать"/>}
                                         tbInfo={{}}
                                         operators={operators}
                                         onSave={handleSave}/>
                    : "",
                key: "actions",
                getBodyCellValue: (tbInfo) => (isAdmin() && !isAdminAsPartner()) && <div style={{display: "flex", opacity: tbInfo.status === TB_STATUS_HIDDEN ? 0.7 : 1}}>
                    <ActionPopover
                        button={<i
                            className={tbInfo.status === TB_STATUS_HIDDEN ? "fa fa-eye-slash" : "fa fa-eye"}
                            title={tbInfo.status === TB_STATUS_HIDDEN ? "Открыть" : "Скрыть"} style={{fontSize: "20px", cursor: "pointer"}}/>}
                        popoverLocation='left'
                        label={tbInfo.status === TB_STATUS_HIDDEN ? 'Отображать партнерам на данной странице?' : 'Скрыть от партнеров на данной странице?'}
                        handleSubmit={() => toggleHiddenFromPartner(tbInfo)}/>
                    <TbInfoEditPopover button={<i className="ti ti-pencil td-save" title="Редактировать"/>}
                                       tbInfo={tbInfo}
                                       operators={operators}
                                       onSave={handleSave}
                    />
                    <ActionPopover
                        button={<i
                            className="ti ti-trash td-save"
                            title="Удалить"/>}
                        popoverLocation='left'
                        label='Удалить?'
                        handleSubmit={() => dispatch(deleteTbInfo(tbInfo.id, () => dispatch(loadTbInfo())))}/>
                </div>,
                headerCellStyle: {textAlign: "right"},
                bodyCellStyle: {textAlign: "right", maxWidth: "100px", width: "100px", paddingRight: "10px"},
                isSortingDisabled: true,
            },
        ]
    };

    const tableActionRow = () => {
        return [
            {
                key: "code",
                getActionCellValue: () => <input
                    name="code"
                    className="form-control"
                    value = {searchData["code"] || ""}
                    onChange={handleTyping}
                    />
            },
            {
                key: "operator",
                getActionCellValue: () => <MaterialUISelect
                    styles={dropDownStyles}
                    dropdownData={operators}
                    selectedValue={selectedOperator}
                    onSelectCallbackFunction={setSelectedOperator}
                    dataField='id'
                    displayedField='name'
                    isClearable
                    isSearchable
                />
            },
            {
                key: "description",
                getActionCellValue: () => <input
                    name="description"
                    className="form-control"
                    value = {searchData["description"] || ""}
                    onChange={handleTyping}/>
            },
            {
                key: "action",
                getActionCellValue: () => <>
                    <i className="ti ti-close td-save" onClick={handleClearSearchData} title='Очистить'/>
                </>
            },

        ]
    };

    const tbDescriptionHeight = (useResizeObserver(document.getElementById("tb-description")).height + 10);
    const height = isDesktop() ? "calc(100dvh - " + tbDescriptionHeight + "px)" : "calc(100dvh - 175px)";

    return (
        <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{height: height, minWidth:"650px", maxWidth: "1900px"}}>
            <SimpleTable tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext"
                         columns={tableColumns()} data={filteredData} bodyRowKey="id" actionRow={tableActionRow()}/>
        </div>
    )
}